import Slider from "@mui/material/Slider";
import { useThrottleFn } from "ahooks";
import cloneDeep from "lodash/cloneDeep";
import sortBy from "lodash/sortBy";
import React from "react";

export default function WholesaleSlider(props): React.ReactElement {
  const { minQauntity = 0, initValue, wholesalePrice, onChange } = props;

  const defaultValue = React.useMemo(() => {
    return initValue;
  }, []);

  const wholesalePricesReversed = React.useMemo(() => {
    return cloneDeep(wholesalePrice).reverse();
  }, []);

  const onWholeSaleChange = (_: Event, newValue: number | number[]) => {
    runChangeWholeDisplay(newValue);
  };

  const onWholeSaleChangeCommitted = (
    _: Event,
    newValue: number | number[]
  ) => {
    changeWholeDisplay(newValue);
  };

  const { run: runChangeWholeDisplay } = useThrottleFn(
    (value: number | number[]) => {
      changeWholeDisplay(value);
    },
    { wait: 300 }
  );

  const changeWholeDisplay = (value: number | number[]) => {
    const quantity = marks.find((item) => item.value === value)?.quantity || 0;
    const wholesalePrice = wholesalePricesReversed.find(
      (item) => item.quantity <= quantity
    );

    onChange &&
      onChange(wholesalePrice ? wholesalePrice.discount : null, quantity);
  };

  const marks = React.useMemo(() => {
    const marks = [];
    const list = sortBy(cloneDeep(wholesalePrice), ["quantity"]);

    for (let i = 0; i < list.length; i++) {
      const item = list[i];
      if ((item.quantity === 0 || item.quantity === 1) && minQauntity === 0) {
        marks.push({
          value: marks.length,
          quantity: item.quantity,
          label: "1",
        });
        continue;
      }

      if (item.quantity < minQauntity) {
        continue;
      } else if (item.quantity === minQauntity) {
        marks.push({
          value: marks.length,
          quantity: item.quantity,
          label: item.quantity,
        });
      } else {
        if (marks.length === 0) {
          marks.push({
            value: marks.length,
            quantity: minQauntity,
            label: minQauntity === 0 ? 1 : minQauntity,
          });
        }
        marks.push({
          value: marks.length,
          quantity: item.quantity,
          label: `${item.quantity}${
            i === wholesalePrice.length - 1 ? "+ " : ""
          }`,
        });
      }
    }
    return marks;
  }, [minQauntity, wholesalePrice]);

  const valuetext = React.useCallback(
    (value: number) => {
      const quantity =
        marks.find((item) => item.value === value)?.quantity || 0;

      const wholesalePrice = wholesalePricesReversed.find(
        (item) => item.quantity <= quantity
      );
      if (!wholesalePrice) {
        return "Discount: 0%";
      }
      return `Discount: ${wholesalePrice.discount}%`;
    },
    [wholesalePricesReversed]
  );

  const maxQauntity = React.useMemo(() => {
    return marks.length - 1;
  }, [wholesalePrice]);

  return (
    <Slider
      defaultValue={defaultValue}
      valueLabelFormat={valuetext}
      min={0}
      max={maxQauntity}
      step={null}
      onChange={onWholeSaleChange}
      onChangeCommitted={onWholeSaleChangeCommitted}
      marks={marks}
      valueLabelDisplay="auto"
    />
  );
}

// export const priceFormatter = (price) => {
//   //Checks if price is an integer
//   if (price == parseInt(price)) {
//     return "$ " + price;
//   }

//   //Checks if price has only 1 decimal
//   else if (Math.round(price * 10) / 10 == price) {
//     return "$ " + price + "0";
//   }

//   //Covers other cases
//   else {
//     return "$ " + Math.round(price * 100) / 100;
//   }
// };
